import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { store } from 'src/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import App from './App';
import 'scroll-behavior-polyfill';
import 'core-js';
import 'flexibility';

const oldConsoleError = console.error;
console.error = function (...args) {
  const msg = args[0];
  try {
    // since these are actually warnings, show them as warning instead
    if (msg && (msg.includes('validateDOMNesting(...)')
            || msg.includes('Warning: Received `%s` for a non-boolean attribute')
            || msg.includes('Warning: React does not recognize the `%s` prop on a DOM element.')
    )
    ) {
      console.warn(...args);
    } else {
      oldConsoleError(...args);
    }
  } catch {
    oldConsoleError(...args);
  }
};

if (document.documentMode || /Edge/.test(navigator.userAgent)) {
  document.getElementById("oldBrowserNotSupportedNotice").style.display = "block";
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// disable scroll for focused numeric inputs with noscroll-class
// if numeric inputs are scrolled, it will be incremented
document.addEventListener('wheel', (event) => {
  if (document.activeElement?.type === 'number' && document.activeElement.classList.contains('noscroll')) {
    document.activeElement.blur();
  }
});
